import queryString from 'query-string';

const urlHandler = (searchURL: (rout: string) => string, nameOfSearch: string) => () => {
  const routs = nameOfSearch === 'practitioner' ? ['/v1/fhir/PractitionerRole'] : ['/v1/fhir/Location'];

  return routs.reduce((acc: string[], rout: string) => {
    const { query } = queryString.parseUrl(searchURL(rout));
    if (Object.keys(query).length <= 3 && query.page) {
      return [...acc];
    }
    return [...acc, searchURL(rout)];
  }, []);
};

export default urlHandler;
